<template>
   <div class="update_pwd_mask"  v-if="updateLevelShow">
    <el-card class="update_pwd">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">修改等级</span>
        </div>
        <el-form :label-position="labelPosition" :rules="rules" label-width="80px" >
            <el-select style="width:200px;" v-model="mylevel" placeholder="请选择商品类型">
                <el-option v-for="item in levelData" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
             <el-form-item>
                <el-button style="width:40%" type="primary" @click="submitForm()" :loading="loading">提交</el-button>
            </el-form-item>
        </el-form>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'
    import md5 from 'js-md5'
    export default {
      props: ['updateLevelShow', 'theId'],
      data () {
        return {
          labelPosition: 'right',
          addShowOk: this.addShow,
          loading: false,
          levelData: [],
          mylevel: 0
        }
      },
      computed: {
        updatePwdOk: function () {
          return this.updatePwdShow
        }
      },
      created: function () {
        this.queryAllLevel()
      },
      methods: {
        queryAllLevel () {
          var _this = this
          _this.loading = true
          $axios.get('/fx/level/list', null, 'headers', function (res) {
            _this.loading = false
            if (res && res.resultStatus === true) {

              if (res.resultData && res.resultData.length > 0) {
                _this.levelData = res.resultData
              }
            } else {
            }
          })

        },
        boxColose () {
          this.$emit('closeUpdateLevel', false)
        },
        submitForm () {
          var _this = this
          var params = {
            id: _this.theId,
            level: _this.mylevel
          }
          var url = '/custom/editUserLevel'
          $axios.post(url, params, 'headers', function (res) {
            _this.loading = false
            if (res.resultStatus) {
              _this.$message({
                message: '修改等级成功！',
                type: 'success'
              })

              _this.$emit('closeUpdateLevel', false)
            } else {
              _this.$message({
                message: '修改等级失败' + res.errorMessage,
                type: 'error'
              })
            }
          }, function (err) {
            _this.loading = false
            _this.$message({
              type: 'error',
              duration: 1000 * 5,
              message: '服务器异常，请稍后再试!' + err
            })
          })


        }


      }
    }
</script>
<style lang="scss">
  .update_pwd_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      .update_pwd {
          width: 400px;
          top: 20%;
          left: 50%;
          z-index: 101;
          margin-left: -200px;
          position: fixed;

          .el-card__header {
              padding: 10px
          }
          .el-card__body {
              padding: 20px 40px;
              .el-form-item {
                  width: 90%
              }
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/page/accountMgr/updateLevel.vue